import { Button, Dialog, DialogActions, DialogContent, Slide, Snackbar } from "@mui/material";
import React, { useRef, useEffect } from "react";
import IMTitle from "../../typography/IMText";
import IMButton from "../buttons/IMButton";
import IMText from "../../typography/IMTitle";

type Props = {
	open: boolean;
	link: string;
	title: string;
	onClose: () => void;
};

const Transition = React.forwardRef(function Transition(
	props: React.ComponentPropsWithoutRef<typeof Slide> & { children?: React.ReactNode },
	ref
) {
	return <Slide direction="up" ref={ref} {...props}>{props.children}</Slide>;
});

const IMShareDialog = ({ open, link, title, onClose }: Props) => {
	const confirmButtonRef = useRef<HTMLButtonElement>(null);
	const [snackbarOpen, setSnackbarOpen] = React.useState(false);

	useEffect(() => {
		if (open && confirmButtonRef.current) {
			confirmButtonRef.current.focus();
		}
	}, [open]);

	const onCopy = () => {
		navigator.clipboard.writeText(link)
			.then(() => {
				setSnackbarOpen(true);
			})
			.catch((err) => console.error("Failed to copy: ", err));
	};

	const handleSnackbarClose = (
		event?: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === 'clickaway') {
			return;
		}
		setSnackbarOpen(false);
	};

	return (
		<>
			<Dialog
				open={open}
				onClose={onClose}
				keepMounted
				slots={{
					transition: Transition
				}}
				slotProps={{
					paper: {
						sx: {
							position: 'fixed',
							bottom: 0,
							margin: 0,
							width: '100%',
							maxWidth: '100vw',
							borderRadius: '12px 12px 0 0',
							height: '300px',
						}
					}
				}}
				fullWidth
			>
				<DialogContent sx={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					justifyContent: 'center',
					overflow: 'hidden'
				}}>
					<IMTitle
						weight="700"
						size="18px"
						color="#212B36"
						textAlign="center"
						props={{ marginBottom: '32px', marginTop: '40px' }}
					>{title}</IMTitle>
					<IMText
						weight="700"
						size="12px"
						color="#909090"
						textAlign="center"
						props={{ marginBottom: '32px', maxWidth: '100%', overflowWrap: 'break-word' }}
						onClick={onCopy}
					>{link}</IMText>

					<DialogActions sx={{
						width: '100%',
						justifyContent: 'center',
						gap: '8px',
						paddingX: '12px',
						height: '48px',
						'& > *': { width: '100%', height: '100%' },
					}}>
						<IMButton color="inherit" onClick={onClose} sx={{ boxShadow: 'none' }}>
							Закрыть
						</IMButton>
						<IMButton
							color="success"
							onClick={onCopy}
							sx={{ boxShadow: 'none' }}
						>
							Копировать
						</IMButton>
					</DialogActions>
				</DialogContent>
			</Dialog>
			<Snackbar
				open={snackbarOpen}
				autoHideDuration={2000}
				onClose={handleSnackbarClose}
				message="Ссылка скопирована в буфер обмена"
				anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
			/>
		</>
	);
}

export default IMShareDialog;